// -- Helpers BEGIN
const documentReady = require("%helpers%/document-ready.js");
const breakpoints = require("%helpers%/breakpoints.js");
// -- Helpers END

documentReady(function() {
	const $header = $(".header"),
		$menu = $(".mobile-menu"),
		$menuBtn = $header.find(".header__menu-btn"),
		$body = $("body"),
		$page = $("html, body");

	$(".header__search-btn").on("click", function(e) {
		e.preventDefault()
		$('.header-search').addClass("header-search--show")
	});

	// -- Functions BEGIN
	const fixedHeaderOnScroll = () => {
		const stickyOffset = $header.offset().top;
		let hasScrolled = false

		function checkScroll () {
			const scrollTop = $(window).scrollTop();

			if (scrollTop > stickyOffset) {
				$header.addClass("header_fixed");
				$body.addClass("page-header-fixed");

				if (!hasScrolled) {
					$header.addClass("header_fixed-first");
				}
				hasScrolled = true;
			}
			else {
				$header.removeClass("header_fixed header_fixed-first");
				$body.removeClass("page-header-fixed");
				hasScrolled = true;
			}
		}

		checkScroll();

		$(window).scroll(function () {
			checkScroll();
		});
	};
	
	const changeStateMenu = () => {
		$menuBtn.toggleClass("header__menu-btn_active");
		$menu.toggleClass("mobile-menu_visible");
		$page.toggleClass("page-fixed");
	};

	const initMenuBtn = () => {
		$menuBtn.on("click", function () {
			changeStateMenu();
		});
	};
	// -- Functions END

	if ($menuBtn.length) initMenuBtn();
	if ($(window).innerWidth() > breakpoints.lg && $header.length) fixedHeaderOnScroll();
});
